<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_vi"><img alt="image" src="images/chapimage.jpg"/></a></p><a id="page_vi">
<p class="dedication"><em>To “Chipmunk” Belle, child of light,<br/>and her fairy rings:</em></p>
<p class="dedication"><em>Club Weirdo:</em></p>
<p class="dedication">Haley “Elvis” Schricker, Jesse “Otter” Greenfield, Emily<br/>“BobThing” Hogan, Steffi “Staff” Sontgerath, and<br/>Julia Jules” and Mandy “Mandy-Candy” Escobedo</p>
<p class="dedication"><em>The Ones Who Were There Before the Beginning:</em></p>
<p class="dedication">Grace Beck, Sarah Wilcox, Melody and Mallory<br/>Muehlbauer, and Alexandra and Anna Rose Morel</p>
<p class="dedication"><em>And with gratitude, love, and deep respect to:</em></p>
<p class="dedication">Melanie Tern,<br/>CLG,<br/>and my mother, Marion Elise Smith</p>
</a><p class="chapimage1"><a id="page_vi"></a><a id="page_vii"><img alt="Image" src="images/chapimage.jpg"/></a></p><a id="page_vii">
<p class="center3"><em>Love is much like a wild rose, beautiful and calm,<br/>but willing to draw blood in its own defense</em>.</p>
<p class="attributionz">—Mark Overby</p>
<p class="center3"><em>Love looks not with the eyes, but with the mind;<br/>And therefore is winged Cupid painted blind</em>.</p>
<p class="attributionz">—William Shakespeare</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?427e7adf